
import HttpClienteToken from '../../services/HttpClientToken';

import { TipoJuicioProps } from '../../interfaces/catalogos/TipoJuicioInterface';

export const TipoJuicio = () => {

    return new Promise<TipoJuicioProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoJuicio/', token)
            .then( ({ data } : { data : TipoJuicioProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoJuicio = () => {

    return new Promise<TipoJuicioProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoJuicio/ObtenerTipoJuicio', token)
            .then( ({ data } : { data : TipoJuicioProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoJuicio = ( params: TipoJuicioProps ) => {

    return new Promise<TipoJuicioProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoJuicio/Actualizar', params, token)
            .then( ({ data } : { data : TipoJuicioProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoJuicio: 0,                 
                    descripcion: '',
                    activo: false,   
                });
            });
        }

    });

}

export const AgregarTipoJuicio = ( params: TipoJuicioProps ) => {

    return new Promise<TipoJuicioProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoJuicio/Agregar', params, token)
            .then( ({ data } : { data : TipoJuicioProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoJuicio: 0,                   
                    descripcion: '',
                    activo: false,   
                });
            });
        }

    });

}